const ADMIN_CENTER_WHITELIST_EMAILS: readonly string[] = [
	"santiago.clemente@windconsul.com",
	"roddy.bonilla@windconsul.com",
];

export const isEmailInAdminCenterWhitelist = (email: string | undefined): boolean => {
	if (!email) return false;
	return ADMIN_CENTER_WHITELIST_EMAILS.includes(email.toLowerCase());
};
